import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=a724b524&scoped=true&"
import script from "./ParticipantList.vue?vue&type=script&lang=ts&"
export * from "./ParticipantList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a724b524",
  null
  
)

export default component.exports